import { render, staticRenderFns } from "./TextWrapped.vue?vue&type=template&id=4fd7a41a&scoped=true&"
import script from "./TextWrapped.vue?vue&type=script&lang=js&"
export * from "./TextWrapped.vue?vue&type=script&lang=js&"
import style0 from "./TextWrapped.vue?vue&type=style&index=0&id=4fd7a41a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd7a41a",
  null
  
)

export default component.exports